export default {
  "首页": "Accueil",
  "订单": "Commandes",
  "新闻": "Actualités",
  "个人中心": "Profil",
  "模拟账户": "Compte Démo",
  "可用资产": "Actifs Disponibles",
  "入金": "Dépôt",
  "出金": "Retrait",
  "账单详情": "Détails de la Facture",
  "重置模拟账户": "Réinitialiser le Compte Démo",
  "钱包": "Portefeuille",
  "实名认证": "Vérification d'Identité",
  "邀请好友": "Inviter des Amis",
  "修改密码": "Modifier le Mot de Passe",
  "投诉邮箱": "Courriel de Réclamation",
  "其它": "Autres",
  "公告": "Annonces",
  "语言": "Langue",
  "是否退出登录": "Voulez-vous vous déconnecter ?",
  "复制": "Copier",
  "复制成功": "Copié avec Succès",
  "发送验证码成功": "Code de Vérification Envoyé avec Succès",
  "请输入密码": "Veuillez Saisir le Mot de Passe",
  "请再次输入密码": "Veuillez Ressaisir le Mot de Passe",
  "复制邀请链接": "Copier le Lien d'Invitation",
  "上传身份": "Veuillez Téléverser le Recto et le Verso de Votre Pièce d'Identité/Passeport",
  "正面": "Recto",
  "上传正面": "Téléverser le Recto de la Pièce d'Identité/Passeport",
  "反面": "Verso",
  "上传反面": "Téléverser le Verso de la Pièce d'Identité/Passeport",
  "完善信息": "Veuillez Compléter Vos Informations Personnelles",
  "输入姓名": "Veuillez Saisir Votre Nom",
  "身份证号": "Numéro de Pièce d'Identité/Passeport",
  "输入身份证号": "Veuillez Saisir Votre Numéro de Pièce d'Identité/Passeport",
  "收款货币": "Devise de Paiement",
  "银行名称": "Nom de la Banque",
  "收款人账户": "Compte du Bénéficiaire",
  "货币": "Devise",
  "分店名称": "Nom de la Succursale",
  "绑定银行卡": "Lier une Carte Bancaire",
  "银行地址": "Adresse de la Banque",
  "账号名称（假名）": "Nom du Compte (Alias)",
  "绑定数字货币地址": "Lier une Adresse de Cryptomonnaie",
  "余额": "Solde",
  "联系客服": "Contacter le Support",
  "行情": "Marché",
  "其他": "Autres",
  "设置": "Paramètres",
  "收款人": "Bénéficiaire",
  "添加": "Ajouter",
  "确认": "Confirmer",
  "取消": "Annuler",
  "钱包地址": "Adresse du Portefeuille",
  "请输入": "Veuillez Saisir",
  "退出登录": "Déconnexion",
  "充值数量": "Montant du Rechargement",
  "提交": "Soumettre",
  "银行卡": "Carte Bancaire",
  "选择网络": "Choisir un Réseau",
  "数字货币": "Cryptomonnaie",
  "上传验证": "Téléverser la Vérification",
  "提币地址": "Adresse de Retrait",
  "数量(USD)": "Montant (USD)",
  "备注": "Remarques",
  "手续费": "Frais",
  "预计到账数量": "Montant Estimé à Recevoir",
  "暂无数据": "Pas de Données Disponibles",
  "入金记录": "Historique des Dépôts",
  "提币记录": "Historique des Retraits",
  "验证码": "Code de Vérification",
  "邀请码": "Code d'Invitation",
  "提示": "Notification",
  "请输入验证码": "Veuillez Saisir le Code de Vérification",
  "姓名": "Nom",
  "邮箱登录": "Connexion par Email",
  "邮箱": "Email",
  "密码": "Mot de Passe",
  "新用户": "Nouvel Utilisateur",
  "立即加入": "Rejoignez Maintenant",
  "忘记密码": "Mot de Passe Oublié",
  "登录": "Connexion",
  "无需开户,立即创建模拟账号进行交易!": "Pas Besoin d'Ouvrir un Compte, Créez un Compte Démo pour Commencer à Trader !",
  "电话": "Téléphone",
  "再次输入密码": "Ressaisir le Mot de Passe",
  "职业": "Profession",
  "年收入": "Revenu Annuel",
  "注册": "Inscription",
  "邮箱注册": "Inscription par Email",
  "发送": "Envoyer",
  "重置密码": "Réinitialiser le Mot de Passe",
  "是否重置": "Réinitialiser ?",
  "已重置": "Réinitialisé",
  "名称": "Nom",
  "注册成功": "Inscription Réussie",
  "加载中": "Chargement",
  "您还未登录，请先登录": "Vous N'êtes pas Encore Connecté, Veuillez Vous Connecter",
  "退出成功": "Déconnexion Réussie",
  "市价": "Prix du Marché",
  "挂单": "Ordre Limité",
  "倍数": "Multiplicateur",
  "止盈": "Prise de Profit",
  "止损": "Stop Loss",
  "买入数量": "Quantité d'Achat",
  "每手": "Par Lot",
  "预估手续费": "Frais Estimés",
  "预估保证金": "Marge Estimée",
  "买入": "Acheter",
  "卖出": "Vendre",
  "您的订单已确认": "Votre Commande a été Confirmée",
  "订单页面": "Page des Commandes",
  "盈亏": "Profits et Pertes",
  "当前保证金": "Marge Actuelle",
  "订单详情": "Détails de la Commande",
  "保证金": "Marge",
  "平仓": "Clôturer la Position",
  "修改": "Modifier",
  "手数": "Lots",
  "暂无数据": "Pas de Données Disponibles",
  "历史": "Historique",
  "价格": "Prix",
  "请输入价格": "Veuillez Saisir le Prix",
  "手": "Lot",
  "搜索结果": "Résultats de Recherche",
  "搜索产品": "Rechercher un Produit",
  "持仓": "Positions",
  "语言": "Langue",
  "审核中": "En Cours de Vérification",
  "请上传证件照正/反面": "Veuillez Téléverser des Photos Recto/Verso de la Pièce d'Identité",
  "上传成功": "Téléversement Réussi",
  "上传失败": "Échec du Téléversement",
  "提交成功": "Soumission Réussie",
  "删除": "Supprimer",
  "删除成功": "Suppression Réussie",
  "提币": "Retrait",
  "缺少参数或传值错误": "Paramètres Manquants ou Valeurs Incorrectes",
  "操作成功": "Action Réussie",
  "充值金额": "Montant du Rechargement",
  "类型": "Type",
  "状态": "Statut",
  "时间": "Temps",
  "单位": "Unité",
  "最高价": "Prix le Plus Haut",
  "最低价": "Prix le Plus Bas",
  "开盘价": "Prix d'Ouverture",
  "请注册或登录真实账号": "Veuillez Vous Inscrire ou Vous Connecter à un Compte Réel",
  "没有更多了": "Pas Plus de Contenu",
  "提现金额": "Montant du Retrait",
  "审核通过": "Vérification Approuvée",
  "审核不通过": "Vérification Rejetée",
  "重新提交": "Soumettre à Nouveau",
  "止盈价": "Prix de Prise de Profit",
  "止损价": "Prix Stop Loss",
  "总盈亏": "Profits et Pertes Totaux",
  "撤单": "Annuler la Commande",
  "请先进行实名认证": "Veuillez Effectuer une Vérification d'Identité d'Abord",
  "产品列表": "Liste des Produits",
  "下单": "Passer une Commande",
  "可用资金": "Fonds Disponibles",
  "欢迎登录": "Bienvenue",
  "可用": "Disponible",
  "冻结": "Gelé",
  "财务记录": "Historique Financier",
  "交易对": "Paire de Trading",
  "开仓时间": "Heure d'Ouverture",
  "收益": "Gains",
  "操作": "Action",
  "下单价": "Prix de Commande",
  "当前价": "Prix Actuel",
  "订单号": "Numéro de Commande",
  "请选择": "Veuillez sélectionner",
  "卖出(做空)止损价不能低于开仓价": "Le prix du stop-loss pour la vente (court) ne peut être inférieur au prix d'ouverture",
  "卖出(做多)止盈价不能高于开仓价": "Le prix de prise de bénéfices pour la vente (long) ne peut être supérieur au prix d'ouverture",
  "买入(做多)止损价不能高于开仓价": "Le prix du stop-loss pour l'achat (long) ne peut être supérieur au prix d'ouverture",
  "买入(做多)止盈价不能低于开仓价": "Le prix de prise de bénéfices pour l'achat (long) ne peut être inférieur au prix d'ouverture",
  "买入(做多)止盈价不能低于开仓价和现价": "Le prix de prise de bénéfices pour l'achat (long) ne peut être inférieur au prix d'ouverture et au prix actuel",
  "买入(做多)止损价不能高于开仓价和现价": "Le prix du stop-loss pour l'achat (long) ne peut être supérieur au prix d'ouverture et au prix actuel",
  "卖出(做空)止损价不能低于开仓价和现价": "Le prix du stop-loss pour la vente (court) ne peut être inférieur au prix d'ouverture et au prix actuel",
  "卖出(做多)止盈价不能高于开仓价和现价": "Le prix de prise de bénéfices pour la vente (long) ne peut être supérieur au prix d'ouverture et au prix actuel",

  "提现手续费": "Frais de retrait",
  "提现退回": "Retrait de retour",
  "系统加款": "Système plus",
  "系统减款": "Réduction du système",

  "交易周期": "Cycle de transaction",
  "秒": "Seconde",
  "交易额": "Montant de la transaction",
  "买涨": "Acheter en espérant une hausse",
  "买跌": "Acheter en espérant une baisse",
  "秒数": "Nombre de secondes",
  "交易类型": "Type de transaction",
  "看涨": "Être bullish",
  "看跌": "Être bearish",
  "剩余时间": "Temps restant",
  "买入价": "Prix d'achat",
  "结算价": "Prix de règlement",
  "交易额": "Montant de la transaction",
  "下单时间": "Heure de placement de la commande",
  "结算时间": "Heure de règlement",
  "该币种暂无交易": "Cette devise n'est pas encore échangée",

  "总资产": "Actifs totaux",
  "币种": "Devise",
  "资产折合": "Conversion des actifs",
  "冻结金额": "Montant bloqué",
  "可用金额": "Montant disponible",
  "公司资产": "Actifs de l'entreprise",
  "请输入旧密码": "Veuillez saisir l'ancien mot de passe",
  "请输入新密码": "Veuillez saisir le nouveau mot de passe",
  "请再次输入新密码": "Veuillez resaisir le nouveau mot de passe",
  "白皮书": "Livret blanc",
  "注册证书": "Certificat d'enregistrement",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "Le droit d'interprétation finale des informations ci-dessus appartient à l'autorité officielle.",
  "上一页": "Page précédente",
  "下一页": "Page suivante",
  "关闭": "Fermer",
  "闪电兑换": "Échange instantané",
  "全部": "Tout",
  "可用余额": "Solde disponible",
  "到": "À",
  "请输入数量": "Veuillez saisir la quantité",
  "币种选择": "Sélection de la devise",
  "从": "De",
  "兑换": "Échanger",
  "兑换成功！": "Échange réussi!",
  "支付": "Payer",
  "全部兑换成功": "Tous les échanges ont réussi",
  "获取": "Obtenir",
  "数量": "quantité",
  "拒绝原因": "Raisons du refus",
  "交易密码": "Mot de passe de transaction",
  "设置交易密码": "Configurer le mot de passe de transaction",
  "重置交易密码": "Réinitialiser le mot de passe de transaction",
  "确定": "Confirmer",
  "是否购买？": "Acheter ?",
  "外汇": "Devises",
  "期权": "Options",
  "(用户中心)": "(Centre utilisateur)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Votre transaction est en cours de traitement, veuillez patienter que la transaction soit terminée avant d'effectuer d'autres opérations !",
  "继续下单": "Continuer la commande",
  "交易方向": "Direction de la transaction",
  "实现盈利": "Réaliser un profit",
  "最新价格": "Dernier prix",
  "结算完成": "Règlement terminé",
  "下单余额不足": "Solde insuffisant pour passer la commande",
  "输入交易额度": "Saisir le montant de la transaction",
  "选择交易周期": "Choisir la période de transaction",
  "审核拒绝": "Vérification refusée",
  "请输入正确的数量!": "Veuillez entrer la quantité correcte !",
  "上传身份": "Télécharger l'identité",
  "上传正面": "Télécharger le recto",
  "上传反面": "Télécharger le verso",
  "完善信息": "Compléter les informations",
  "输入姓名": "Saisir le nom",
  "输入身份证号": "Saisir le numéro d'identité",
  "身份证号": "Numéro d'identité",
  "请上传证件照正/反面": "Veuillez télécharger le recto/verso du document",
  "最小提现金额10USDT": "Le montant minimum de retrait est de 10 USDT",
  "证件号码": "Numéro d'identification",
  "输入证件号码": "Entrez le numéro d'identification",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Veuillez télécharger votre carte d'identité, permis de conduire ou passeport pour la vérification d'identité !"


}
